<template>
  <div class="detail-padding">
    <div
      style=" text-align: left; background: linear-gradient( 45deg, #020202 0%, #001A49 100%); color:white; border-radius: 0.16rem;  padding:20px; margin-bottom:20px; font-size: 20px; font-family: HurmeGeometricSans2-SemiBold; border: 1px solid #606266;"
    >
      <img style="width: 20px; height: 20px;" src="@/assets/image/announcement.png"/><br/>
      The Treasurenet network has completed its latest upgrade, and the REP Bid mechanism is now live on mainnet.<br/><br/>
      REP holders can now bid REP to unlock Bonus UNIT rewards, activating the full validator reward logic across the network.<br/><br/>
      Users may earn REP by doing real-world productive activity that the network can verify. We will continue to introduce additional REP sources as the ecosystem expands.<br/><br/>
      <a href="https://docs.treasurenet.io/docs/5/REP%20Score">Learn more about REP</a><br/><br/>
      <a href="https://docs.treasurenet.io/docs/6/What%20is%20Bonus%20Stake">Learn more about REP Bonus Staking</a>
    </div>

    <div class="spaceBetween" style="margin-bottom: 0.24rem">
      <div class="spaceLeft">
        <!-- 这里如果你想更准确一点，可以从 Active Validators 改成 Validators -->
        <div class="detail-title-1">Validators</div>
        <el-button
          type="text"
          style="margin-left: 0.16rem; color: #3172fd !important;font-family: HurmeGeometricSans2-SemiBold;"
          @click="toProfile"
        >
          STAKED RECORD<i class="el-icon-d-arrow-right" />
        </el-button>
      </div>
    </div>

    <div class="common-card is-border">
      <div class="common-card-main">
        <!-- 新增 :row-class-name 用于高亮 active validator -->
        <el-table
          class="common-table"
          :data="tableList"
          v-loading="loading"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            type="index"
            label=" "
            width="30px"
          ></el-table-column>

          <!-- 显示所有 validators，并在名字旁边标记 active -->
          <el-table-column prop="operator_address" label="Validators">
            <template slot-scope="{ row }">
              <div class="userinfo">
                <div class="img">
                  <img
                    v-if="row.description.pictures"
                    :src="row.description.pictures"
                    alt=""
                  />
                  <img v-else src="@/assets/image/stake/icon.png" alt=""/>
                </div>
                <span class="name">{{ row.description.moniker }}</span>

                <!-- Active 标记 -->
                <span
                  v-if="row.status === 'BOND_STATUS_BONDED'"
                  class="tag-active"
                >
                  Active
                </span>

                <span
                  class="web"
                  v-if="row.description.website"
                  @click="handleOpen(row.description.website)"
                ></span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Stake" align="right">
            <template slot="header">
              Stake
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" style="text-align:center">
                  The first number displayed is the amount of UNIT staked with
                  this validator.<br/>
                  The percentage indicates how much these shares account for the
                  total <br/>
                  amount of stake UNIT in the network.
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <div>
                <big-number :number="row.tokens"/>
                <span class="td-word-sm">UNIT</span>
              </div>
              <div>
                <Ratio
                  style="font-size:14px"
                  :count="2"
                  :number="row.delegator_shares"
                />
                <span style="font-size:14px" class="td-word-sm">%</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Expected APR" align="right">
            <template slot="header">
              Expected APR
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content" style="text-align:center">
                  This is an estimate of the annualized return<br/> from staking, based on historical performance.<br/> Future performance may vary.
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="{ row }">
              <span class="td-word-sm">{{ row.apy }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="operation" label=" " align="right">
            <template slot-scope="{ row }">
              <el-button class="btn" @click="handleStake(row)">Stake</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          :total.sync="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList()"
        />
      </div>
    </div>

    <StakeDia ref="StakeDia" @success="getList"></StakeDia>
  </div>
</template>

<script>
import {validatorsList, getRewards, getUserInfo, getDelegationList} from "@/api/stake/stake.js";
import {getValidatorAPY} from "@/api/stake/base";
import StakeDia from "@/views/stake/activeValidators/StakeDia.vue";
import Ratio from "@/components/BigNumber/ratio";

export default {
  components: {StakeDia, Ratio},
  data() {
    return {
      loading: false,
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      account: "",
      tableList: []
    };
  },
  watch: {
    "$store.getters.metaMaskObj.account": {
      handler(newValue) {
        this.account = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      const params = {
        limit: this.queryParams.pageSize,
        offset: this.queryParams.page
        // 去掉 status: "BOND_STATUS_BONDED"，获取所有 validators
      };
      validatorsList(params)
        .then(res => {
          const list = res.validators || [];
          const promiseList = [];
          list.forEach(item => {
            promiseList.push(this.getUserInfo(item));
            promiseList.push(this.getAPY(item));
          });
          Promise.all(promiseList).then(() => {
            this.tableList = list.sort((a, b) => {
              const aActive = a.status === 'BOND_STATUS_BONDED';
              const bActive = b.status === 'BOND_STATUS_BONDED';
              return (aActive === bActive) ? 0 : aActive ? -1 : 1;
            });
            console.log(this.tableList);
          });
          this.queryParams.total = Number(res.pagination.total) || 0;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAPY(row) {
      getValidatorAPY(row.description.moniker.toLowerCase()).then(res => {
        const apy = (res.data / (row.tokens / 1e18) * 100).toFixed(2) + '%';
        this.$set(row, 'apy', apy);
      });
    },
    getUserInfo(row) {
      if (row.description && row.description.identity) {
        getUserInfo(row.description.identity).then(res => {
          if (res.them && res.them.length > 0) {
            this.$set(
              row.description,
              "pictures",
              res.them[0].pictures.primary.url
            );
          }
        });
      } else {
        row.description.pictures = null;
      }
    },
    handleGetRewards(row) {
      return new Promise((resolve, reject) => {
        getRewards(row.operator_address)
          .then(res => {
            row.rewards = res.rewards.rewards[0].amount;
            resolve(row);
          })
          .catch(() => {
            reject();
          });
      });
    },
    handleStake(row) {
      if (this.account === "") {
        this.$message.error("You need to log in to your wallet to continue.");
        return;
      }
      if (this.getToken()) {
        this.$refs.StakeDia.show(row);
      } else {
        this.$message.warning(
          "You must sign in to the wallet to view this page!"
        );
      }
    },
    toProfile() {
      this.$router.push("/Stake/profile");
    },
    handleOpen(url) {
      window.open(url, "_blank");
    },
    // 根据 status 给行加样式
    tableRowClassName({ row }) {
      if (row.status === 'BOND_STATUS_BONDED') {
        return 'active-row';
      }
      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.userinfo {
  display: flex;
  gap: 0.1rem;
  margin-top: 0.05rem;

  .img {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .name {
    font-size: 0.2rem;
    font-weight: 500;
    font-family: PlusJakartaDisplay-Medium;
    color: #ffffff;
    line-height: 0.28rem;
  }

  .web {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 0.17rem;
    background: url("~@/assets/image/stake/web.png") no-repeat center #efefef;
    cursor: pointer;
  }
}

/* Active 小标签 */
.tag-active {
  margin-left: 0.08rem;
  padding: 0 0.08rem;
  border-radius: 0.12rem;
  font-size: 12px;
  line-height: 2.4;
  border: 1px solid rgba(46, 204, 113, 0.6);
  background: rgba(46, 204, 113, 0.12);
  color: #2ecc71;
}

/* 高亮 active 行 */
::v-deep .el-table .active-row > td {
  background: rgba(49, 114, 253, 0.08) !important;
}

.btn {
  width: 108px;
  height: 44px;
  background: linear-gradient(
      90deg,
      rgba(34, 91, 252, 0) 0%,
      rgba(34, 91, 252, 0.38) 67%,
      #225bfc 100%
  );
  color: #ffffff;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
}
</style>
